module.exports = __webpack_public_path__ + "static/assets/9b086aaec17d933e7d910a84b2cce7a5.svg";